export const AFTER_LOGIN_STORAGE_KEY = 'afterLogin';
export const CREATOR = 'creator';

export const ACCESS_TOKEN = 'std_control';
